export default __webpack_public_path__ + "static/media/edgePng.668bdd97.png";